import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TrustCredentials = () => {
  const credentials = [
  {
    icon: "Award",
    title: "Certified Master Tradesman",
    description: "Fully licensed and certified with 30+ years of proven expertise in plumbing and electrical services"
  },
  {
    icon: "Wrench",
    title: "Decades of Experience",
    description: "30+ years of proven expertise in plumbing and electrical services"
  },
  {
    icon: "CheckCircle",
    title: "Quality Guarantee",
    description: "All work backed by comprehensive warranties"
  },
  {
    icon: "Users",
    title: "Trusted by Major Brands",
    description: "Preferred contractor for McDonald's, KFC, and leading commercial clients"
  }];


  const certifications = [
  "Licensed Master Plumber",
  "Certified Electrician",
  "Commercial Installation Specialist",
  "Safety Compliance Certified"];


  return (
    <section className="py-12 md:py-16 lg:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="text-center mb-8 md:mb-12 lg:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-5xl font-bold text-foreground mb-4">
            Trust & Credentials
          </h2>
          
          <p className="text-base md:text-lg lg:text-xl text-muted-foreground max-w-3xl mx-auto">
            Backed by certifications, and decades of proven excellence in residential and commercial services
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 mb-12 md:mb-16 lg:mb-20">
          {credentials?.map((credential, index) =>
          <div key={index} className="bg-card rounded-xl p-6 md:p-8 shadow-elevated border border-border text-center hover:shadow-lg transition-all duration-300">
              <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-primary/10 rounded-full mb-4">
                <Icon name={credential?.icon} size={32} color="var(--color-primary)" />
              </div>
              
              <h3 className="text-base md:text-lg font-bold text-foreground mb-2">
                {credential?.title}
              </h3>
              
              <p className="text-sm md:text-base text-muted-foreground">
                {credential?.description}
              </p>
            </div>
          )}
        </div>
{/* 
        <div className="bg-card rounded-2xl p-6 md:p-8 lg:p-12 shadow-elevated border border-border">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
            <div className="flex-1">
              <h3 className="text-xl md:text-2xl lg:text-3xl font-bold text-foreground mb-4 md:mb-6">
                Professional Certifications
              </h3>
              
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4 mb-6 md:mb-8">
                {certifications?.map((cert, index) =>
                <div key={index} className="flex items-center gap-3 bg-muted p-3 md:p-4 rounded-lg">
                    <Icon name="BadgeCheck" size={24} color="var(--color-success)" />
                    <span className="text-sm md:text-base font-semibold text-foreground">{cert}</span>
                  </div>
                )}
              </div>

              <p className="text-sm md:text-base text-muted-foreground mb-6">
                All certifications are current and verified. We maintain the highest standards of professional excellence and stay updated with the latest industry regulations and best practices.
              </p>

              <div className="flex items-center gap-4 text-accent">
                <Icon name="Phone" size={24} />
                <div>
                  <p className="text-xs md:text-sm text-muted-foreground">Verify credentials</p>
                  <a href="tel:0827935785" className="text-lg md:text-xl font-bold hover:text-accent/80 transition-colors">
                    082 793 5785
                  </a>
                </div>
              </div>
            </div>

            <div className="flex-shrink-0">
              <div className="w-full lg:w-80 aspect-square rounded-xl overflow-hidden shadow-lg">
                <Image
                  src="https://img.rocket.new/generatedImages/rocket_gen_img_15eb1441e-1763296236396.png"
                  alt="Professional tradesman Gert van Rooyen in work uniform holding tools standing confidently in front of service van"
                  className="w-full h-full object-cover" />

              </div>
            </div>
          </div>
        </div> */}
      </div>
    </section>);

};

export default TrustCredentials;